import {useDispatch, useSelector} from "react-redux";

import {setLanguage} from "@/actions";

export function LanguageSwitcher() {
	const dispatch = useDispatch();
	const current = useSelector((s) => s.language);

	return (
		<div className="d-flex flex-column align-items-center gap-1">
			<img
				style={{
					cursor: "pointer",
					width: "24px",
					border: current === "it" ? "2px solid green" : "",
				}}
				src={require("@/assets/images/italy.png")}
				alt=""
				onClick={() => dispatch(setLanguage("it"))}
			/>
			<img
				style={{
					cursor: "pointer",
					width: "24px",
					border: current === "en" ? "2px solid green" : "",
					backgroundColor: "#fff",
				}}
				src={require("@/assets/images/english.png")}
				alt=""
				onClick={() => dispatch(setLanguage("en"))}
			/>
		</div>
	);
}
